import {
  SET_PREGNANT_WOMEN_DATA,
  SET_CHILD_DATA,
  SET_FAMILY_PLANNING_DATA,
  SET_HEALTH_PROVIDERS_DATA,
  SET_HEALTH_FACILITIES_DATA,
  facilityDashboardType,
  SET_HIERARCHY_FILTER_DASHBOARD
} from '@store/types/facilityDashboardTypes';
export interface DashboardState {
    pregnantWomenData: any,
    childData: any,
    familyPlanningData: any,
    healthProvidersData: any,
    healthFacilitiesData: any,
    hierarchyFiltersDashboard: {
      pregnantWomen:any,
      child:any,
      familyPlanning:any,
      healthProviders:any,
      healthFacilities:any
    }
};
const initialState: DashboardState = {
  pregnantWomenData: null,
  childData: null,
  familyPlanningData: null,
  healthProvidersData: null,
  healthFacilitiesData: null,
  hierarchyFiltersDashboard: {
    pregnantWomen: null,
    child: null,
    familyPlanning: null,
    healthProviders: null,
    healthFacilities: null
  },
};

const facilityDashboardReducer = (
  state = initialState,
  action: facilityDashboardType,
) => {
  switch (action.type) {
    case SET_PREGNANT_WOMEN_DATA:
      return { ...state, pregnantWomenData: action.payload };
    case SET_CHILD_DATA:
      return { ...state, childData: action.payload };
    case SET_FAMILY_PLANNING_DATA:
      return { ...state, familyPlanningData: action.payload };
    case SET_HEALTH_PROVIDERS_DATA:
      return { ...state, healthProvidersData: action.payload };
    case SET_HEALTH_FACILITIES_DATA:
      return { ...state, healthFacilitiesData: action.payload };
    case SET_HIERARCHY_FILTER_DASHBOARD:
      return { ...state,hierarchyFiltersDashboard:
                    {
          ...state.hierarchyFiltersDashboard,
          ...action.data 
        }};
    default:
      return state;
  }
};

export default facilityDashboardReducer;
